<dx-text-area [height]="this.height" [(value)]="value" [maxLength]="props.maxLength" [readOnly]="props.readOnly" (onValueChanged)="handleValueChange($event)"></dx-text-area>
